import React, { useContext, useEffect } from "react";
import { Grid, Button, Icon } from "semantic-ui-react";
import SuccessfulDian from "./graphics/SuccessfulDian";
import FailedDian from "./graphics/FailedDian";
import CountAllSuccess from "./graphics/CountAllSuccess";
import SuccessfulDianPayrolls from "./graphics/SuccessfulDianPayrolls";
import FailedDianPayrolls from "./graphics/FailedDianPayrolls";
import CountAllSuccessPayrolls from "./graphics/CountAllSuccessPayrolls";
import { RootStoreContext } from "../../app/stores/rootStore";
import { observer } from "mobx-react-lite";

const DashboardHome: React.FC = () => {
  document.title = "Majim-e Factura Electrónica";
  const rootStore = useContext(RootStoreContext);
  const { lastUpdate, update, getDash } = rootStore.dashboardStore;
  
  useEffect(() => {
    getDash();
  }, [getDash]);

  return (
    <div className="configurationContent">
      <Button color="blue" className="dashUpdateButton" onClick={update}>        
        <Icon name="redo" />
        Actualizar
      </Button>
  <label>   Última actualización: {lastUpdate}</label>
      <br />
      <br />
      <Grid centered relaxed stackable>
        <Grid.Row columns={3}>
          <Grid.Column>
            <CountAllSuccess />
          </Grid.Column>
          <Grid.Column>
            <SuccessfulDian />
          </Grid.Column>
          <Grid.Column>
            <FailedDian />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={3}>
          <Grid.Column>
            <CountAllSuccessPayrolls />
          </Grid.Column>
          <Grid.Column>
            <SuccessfulDianPayrolls />
          </Grid.Column>
          <Grid.Column>
            <FailedDianPayrolls />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default observer(DashboardHome);
